import React from "react";
/**
 * Fortschrittsbar
 * @param {number} value - Wert zwischen 0 und 100
 * @param {string} color - Farbe des gefüllten Bereichs (default: grün)
 * @param {string} trackColor - Farbe des Hintergrunds
 * @param {number} height - Höhe in px
 */

export default function MyProgressBar({ rounded = false, value = 0, color = "#090", trackColor = "#eee", height = 10 }) {
   const clamped = Math.min(100, Math.max(0, value));

   return (
      <div
         style={{
            width: "calc(100% - 0px)",
            height: `${height}px`,
            background: trackColor,
            borderRadius: rounded ? height / 2 : "0px",
            overflow: "hidden",
            margin: "10px 0",
         }}
      >
         <div
            style={{
               width: `${clamped}%`,
               height: "100%",
               background: color,
               borderRadius: rounded ? height / 2 : "0px",

               transition: "width 0.8s ease",
            }}
         />
      </div>
   );
}
